import { PermissionKeys } from '@client/api';
import { useSpacePermissions } from '../../hooks/useSpacePermissions/useSpacePermissions';
import { useUserPermission } from '../../hooks/useUserPermission/useUserPermission';
import { Button } from '@client/toolkit';

export function AgreementCreateButton({
  spaceId,
  onClick,
  title,
  disabled,
}: {
  spaceId: string;
  onClick: () => void;
  title: string;
  disabled: boolean;
}) {
  const { hasAnyPermission: hasAnyUserPermission } = useUserPermission();
  const { hasAnyPermission: hasAnySpacePermission } = useSpacePermissions({ id: spaceId });
  if (
    !hasAnySpacePermission([PermissionKeys.Agreement.Create]) &&
    !hasAnyUserPermission([PermissionKeys.Tenant.AgreementCreate])
  )
    return null;
  return (
    <Button color="primary" disabledVariant="dark" size="sm" disabled={disabled} onClick={onClick}>
      {title}
    </Button>
  );
}
